export const ALLOW = 'allow'
export const FUNCTION = 'function'
export const IF = 'if'
export const IN = 'in'
export const IS = 'is'
export const LET = 'let'
export const MATCH = 'match'
export const RETURN = 'return'
export const SERVICE = 'service'
